import React, { useState } from "react";
import {ProjectFilterNumberContext, ProjectFilterNumberProps} from "./project-filter-number-props.ts";

const ProjectFilterNumberProvider: React.FC<React.PropsWithChildren> = ({children}) => {
    const [filteredProjectNumber, setFilteredProjectNumber] = useState(0)
    
    const contextProps: ProjectFilterNumberProps = {
        filteredProjectNumber,
        setFilteredProjectNumber
    };
    
    return (
        <ProjectFilterNumberContext.Provider value={contextProps}>
            {children}
        </ProjectFilterNumberContext.Provider>
    )
}

export default ProjectFilterNumberProvider;